import { useState } from "react";
import Button from "../../../../components/form/button";
import DataLabel from "../../../../components/ui/DataLabel";
import ImagePreviewer from "../../../../components/ui/image-previewer";
import { useSingleBusinessVerification } from "../../../../composables/business-merchant/verification/useSingleBusinessVerification";
import { strReplace, ucFirst } from "../../../../lib/helper-support";
import { useApi } from "../../../../providers/ApiProvider";
import DefaultModal from "../../../../components/modal/default-modal";
import FlagReasonModal from "./flag-reason-modal";

const OwnerInformationVerification = ({ open, code, onClose, verified }: { open: boolean, code: string, onClose?: () => void, verified: boolean }) => {
    const [openImage, setOpenImage] = useState(false);
    const { data } = useSingleBusinessVerification({
        type: 'owner_information',
        enabled: open && !!code,
        code,
    });

    const api = useApi();

    const [openFlag, setOpenFlag] = useState(false);

    const approval = async (flagReason?: string) => {
        const status = flagReason ? 'rejected' : 'approved';
        const res = await api.POST({
            endpoint: `business-merchant/${code}/documentation/approval`,
            payload: {
                type: 'owner_information',
                status,
                flagged_reason: flagReason,
            },
            refreshKeys: [
                ['business-merchant', 'documentation', code],
            ],
        });

        if (!res) return;
        setOpenFlag(false);
        onClose && onClose();
    }

    return (
        <>
            <FlagReasonModal
                open={openFlag}
                onClose={() => setOpenFlag(false)}
                submitReason={approval}
                submitting={api.postLoading}
            />

            <div className="space-y-4 grid">
                <div className="grid md:grid-cols-2 gap-4">
                    <DataLabel label="First Name" value={ucFirst(data?.first_name || '-')} />
                    <DataLabel label="Last Name" value={ucFirst(data?.last_name || '-')} />
                    <DataLabel label="Email" value={data?.email || '-'} />
                    <DataLabel label="Phone Number" value={data?.phone || '-'} />
                    <DataLabel label="Means of Identification" value={<span className="capitalize">{strReplace(data?.id_type || '-', '_', ' ')}</span>} />
                    <DataLabel label="Identification Number" value={data?.id_number || '-'} />
                </div>
                <DataLabel label="Address" value={data?.address || '-'} />
                <div>
                    <div>
                        <Button onClick={() => setOpenImage(true)} design="primary-outline" text="View Proof of Address" />
                        <ImagePreviewer open={openImage} onClose={() => setOpenImage(false)} image={data?.proof_of_address?.url} />
                    </div>
                </div>
                {!verified && (
                    <div className="flex gap-4 flex-wrap">
                        <DefaultModal
                            onConfirmationAction={() => approval()}
                            modalButtonTriggerText={<Button text="Approve" />}
                            description="Are you sure you want to approve the supplied information?"
                        />
                        <Button onClick={() => setOpenFlag(true)} text="Flag an issue" design="primary-danger-outline" />
                    </div>
                )}
            </div>
        </>
    )
}

export default OwnerInformationVerification